import { z } from 'zod'

export type OrderScheme = z.infer<typeof orderScheme>

export const orderScheme = z.object({
  hasOneTimeInvestment: z.boolean(),
  oneTimeInvestmentAmount: z.number(),
  hasMonthlyInvestment: z.literal(true),
  monthlyInvestmentAmount: z.number(),
  investmentProductId: z.string(),
  riskAcknowledged: z.boolean().refine((val) => val === true, {
    message: 'Risk acknowledgment is required',
  }),
  durationInMonths: z.number(),
})
